export const USER_ROLES = [
  { value: 'shopTechnician', label: 'Technician' },
  { value: 'shopMarketing', label: 'Marketing' },
  { value: 'shopReceptionist', label: 'Receptionist' },
  { value: 'shopAdmin', label: 'Manager' },
];

export const getStatusBadgeStyle = (status) => {
  switch (status) {
    case 'ACTIVE':
    case 'Active':
      return 'bg-[#22C55E]/20 text-[#4ADE80] border-[#22C55E]/30';
    case 'QUEUED':
    case 'Queued':
      return 'bg-[#8B5CF6]/20 text-[#A78BFA] border-[#8B5CF6]/30';
    case 'CANCELLED':
    case 'Cancelled':
    case 'Paused':
      return 'bg-[#F59E0B]/20 text-[#FBBF24] border-[#F59E0B]/30';
    case 'EXPIRED':
    case 'Expired':
    case 'Inactive':
      return 'bg-[#EF4444]/20 text-[#F87171] border-[#EF4444]/30';
    default:
      return 'bg-[#334155] text-[#94A3B8] border-[#475569]';
  }
};

export const getRoleBadgeStyle = (role) => {
  switch (role) {
    case 'shopAdmin':
      return 'bg-[#2563EB]/20 text-[#60A5FA] border-[#2563EB]/30';
    case 'shopReceptionist':
      return 'bg-[#0EA5E9]/20 text-[#38BDF8] border-[#0EA5E9]/30';
    case 'shopMarketing':
      return 'bg-[#F59E0B]/20 text-[#FBBF24] border-[#F59E0B]/30';
    case 'shopTechnician':
    default:
      return 'bg-[#22C55E]/20 text-[#4ADE80] border-[#22C55E]/30';
  }
};

export const getRoleLabel = (role) => {
  const found = USER_ROLES.find(r => r.value === role);
  return found ? found.label : role;
};
